import { Injectable, inject } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private cookieService = inject(CookieService);

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    let token = this.cookieService.get('accessToken');

    if (/\/eisapi\//.test(request.url)) {
      token = this.cookieService.get('token');
    }

    if (token) {
      const auth_request = request.clone({
        setHeaders: { Authorization: 'Bearer ' + token },
      });
      return next.handle(auth_request);
    }
    return next.handle(request);
  }
}
